import { useState, useEffect } from 'react'
import '../assets/styles/styles.css'
import Toast from 'react-bootstrap/Toast';
import ToastContainer from 'react-bootstrap/ToastContainer';
function BootstrapToast({ position, visible, background, setShowToast, text }) {
  return (
    <ToastContainer position={position}>
      <Toast
        onClose={() => { setShowToast && setShowToast(false) }}
        show={visible}
        delay={2000}
        bg={background}
        autohide
      >
        <Toast.Body>
          <h1 className="container-title" style={{ fontSize: "25px" }}>{text}</h1>
        </Toast.Body>
      </Toast>
    </ToastContainer>
  )
}

export default BootstrapToast;